import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import { SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY } from './useQueryShipmentOrderLegRuns';

const requestPath = '/api/v4/master/delete_all/places';

export const useDeleteAllPlacesMutation = () => {
  const queryClient = useQueryClient();

  return {
    post: useMutation({
      mutationFn: () => axios.post(requestPath),

      // 呼び出し側は DataGrid のキー（usePlacesRequest）しか無効化していないため、
      // フォームの地点候補が読む ['places']（useQueryPlaces）はここで無効化する。
      //
      // leg-run も捨てるのは、主要倉庫の判定 (log_web_issues#318) が legRun のフラグに
      // 載っており、leg-run 一覧が staleTime: Infinity のため。全削除は主要倉庫も消すので、
      // 捨てないと配車画面が「まだ拠点が登録されている」判定のまま残る。
      onSuccess: () => Promise.all([
        queryClient.invalidateQueries({ queryKey: ['places'] }),
        queryClient.invalidateQueries({ queryKey: [SHIPMENT_ORDER_LEG_RUNS_QUERY_KEY] }),
      ]),
    }),
  };
};
